/**
 * Integrytas Group — StatStrip (common).
 *
 * The Direction-D stat strip: value/label pairs (19/700 value, 11/500 +0.3
 * uppercase label) separated by 1px vertical dividers — NOT boxed cards. Sits
 * between the page header and the content card (design/desktop/README.md).
 *
 *   <StatStrip stats={[
 *     { value: users.length,           label: t('users.stat.total', 'Total users') },
 *     { value: activeCount,            label: t('users.stat.active', 'Active') },
 *   ]} />
 *
 * Values are caller-supplied (already-formatted numbers/nodes); labels are
 * already-localized strings.
 */

import { Fragment, type ReactNode } from 'react';

export interface StatItem {
  value: ReactNode;
  label: string;
}

interface StatStripProps {
  stats: StatItem[];
  className?: string;
}

export function StatStrip({ stats, className = '' }: StatStripProps) {
  return (
    <div className={'flex flex-wrap items-center ' + className}>
      {stats.map((stat, i) => (
        <Fragment key={stat.label}>
          {i > 0 && <div className="mx-[26px] h-[30px] w-px shrink-0 bg-csm-line" aria-hidden />}
          <div className="flex flex-col gap-[2px]">
            <span className="text-csm-stat text-csm-ink">{stat.value}</span>
            <span className="text-csm-stat-label uppercase text-csm-muted">{stat.label}</span>
          </div>
        </Fragment>
      ))}
    </div>
  );
}
